// extracted by mini-css-extract-plugin
export default {"container":"mk-z","disabled":"nk-z","subtotal":"ok-z","legal":"pk-z"};